export const ErrorVariant = {
  403: 0,
  404: 1,
};
